import { useEffect, useMemo } from "react";
import { FormState } from "../../FormComponents/FormState";
import BackButton from "../../Shared/BackButton";
import FormPage from "../../Shared/FormPage";
import Layout from "../../Shared/Layout";
import { Container } from "@material-ui/core";
import classNames from "classnames";
import { useSyncOrderState } from "../../hooks/useSyncOrderState";
import { usePage } from "@inertiajs/inertia-react";
import { docsAmazonConfig } from "../../config/docsAmazonConfig";
import { Trans } from "../../utils/i18n";

const SuccessPage = function ({ response }) {
  // TODO: Replace this later by calling Inertia::location from the controller
  useEffect(() => {
      if (!response?.checkout_url || !window) return;
      window.location.href = response.checkout_url;
  }, [response?.checkout_url]);


  return (
      <div>
          Success!
      </div>
  );
}

export default function Documentation({
    requesttypes,
    user,
    orderControllerConfig,
}) {
    const { client } = usePage().props;
    const { defaultFormValues, defaultOrderEntryState, isMetadataLoading, hasOrderNumber } = useSyncOrderState({
        queryKey: ["shop"]
    });
    const formConfig = client?.key === 'amazon' ? docsAmazonConfig : null;
    const defaultState = useMemo(() => {
        return {
            orderControllerConfig: orderControllerConfig
                ? {
                      enableStepper: !!formConfig.enableStepper,
                      ...orderControllerConfig,
                  }
                : { enableStepper: !!formConfig.enableStepper },
        };
    }, []);

    // Since we want to initialize the form and the order state based on the metadata
    // of the order, we need to wait until the metadata is loaded.
    if (hasOrderNumber && isMetadataLoading) {
        return null;
    }

    if (!formConfig) {
        return null;
    }

    return (
        <FormState defaultState={{
            ...defaultState,
            ...defaultOrderEntryState,
        }}>
            <div className={classNames("pt-12 -mt-12 pb-24 -mb-24 min-h-full")}>
                <Container maxWidth="md">
                    { user ? (
                        <BackButton />
                    ) : (
                        <BackButton href={route('home')} label={<Trans i18nKey="common.home">Home</Trans>} />
                    )}

                    <FormPage
                        requesttypes={requesttypes}
                        orderEntryConfig={formConfig}
                        endpointUrl={route("order")}
                        SuccessPage={formConfig?.success || SuccessPage}
                        defaultValues={{
                            ...formConfig.defaultValues,
                            ...defaultFormValues,
                        }}
                    />
                </Container>
            </div>
        </FormState>
    );
}

Documentation.layout = (page) => <Layout children={page} />;
